import apiClient from "./client";

export function getUserPermissions() {
  return apiClient.get("/users/permissions").then((res) => res.data);
}

export function getUsers() {
  return apiClient.get("/users").then((res) => res.data);
}

export function createUser(payload) {
  return apiClient.post("/users", payload).then((res) => res.data);
}

export function deleteUser(id) {
  return apiClient.delete(`/users/${id}`);
}

export function setUserRole(id, role) {
  return apiClient.put(`/users/${id}/role`, { role });
}

export function updateUser(id, payload) {
  return apiClient.put(`/users/${encodeURIComponent(id)}`, payload);
}

export function changeUserPassword(id, newPassword) {
  return apiClient.put(`/users/${encodeURIComponent(id)}/password`, { newPassword });
}
